<script setup lang="ts">
import { Rules } from '@mp/utils'
import type { FormInstance, FormRules } from 'element-plus'
import { reactive, ref } from 'vue'
import { loginPwdReset } from '@mp/api/sdpSecurity/LoginPwdController.js'
import { useMutation } from '@tanstack/vue-query'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import { useUserInfo } from '@mp/hooks'

const route = useRoute()
const router = useRouter()
const { userInfo } = useUserInfo()

const formRef = ref<FormInstance>()
const formState = reactive<{
  password: string | undefined
  rePassword: string | undefined
}>({
  password: undefined,
  rePassword: undefined,
})

const formRules = reactive<FormRules>({
  password: [{ required: true, message: '请输入新登录密码' }, { pattern: Rules.password, message: '请输入正确的密码格式' }],
  rePassword: [{ required: true, message: '请重新输入新登录密码' }, { validator: validatePass2 }],
})

// #重置登录密码
const { mutateAsync: mutateReset, isLoading } = useMutation({
  mutationFn: loginPwdReset,
  onSuccess({ resultCode }) {
    if (resultCode !== 'SUCCESS')
      return
    ElMessage.success('密码重置成功')
    router.replace({ name: 'HomePage' })
  },
})

function validatePass2(_rule: any, value: any, callback: any) {
  if (value !== formState.password)
    callback(new Error('两次密码输入不一致'))

  callback()
}

async function handleSubmit() {
  await formRef.value?.validate()
  mutateReset({
    newLoginPassword: formState.password,
    confirmLoginPassword: formState.rePassword,
    operatorId: userInfo?.value?.operatorId,
  })
}
</script>

<template>
  <section class="bg-white container mx-auto my-12 rounded-lg px-4 py-8 min-h-[calc(100vh-300px)]">
    <el-form ref="formRef" :model="formState" :rules="formRules" class="w-[400px] mx-auto" label-position="top">
      <h1 class="text-xl text-n-800 font-medium">
        设置新登录密码
      </h1>
      <p
        class="text-n-90 text-sm mt-1 mb-8"
      >
        {{ route.query?.first ? '首次登录用户，为了您的账户安全，请先重置你的登录密码' : '您的登录密码已90天未修改，为了您的账号安全，请修改您的登录密码。' }}
      </p>

      <el-form-item label="新登录密码" prop="password">
        <el-input v-model="formState.password" :name="Math.random().toString(36).substring(2, 15)" autocomplete="new-password" type="password" placeholder="请输入新登录密码" />
        <p class="text-xs text-gray mt-2">
          8-20位，至少包括数字、大写字母、小写字母或特殊字符中的三种字符类型
        </p>
      </el-form-item>
      <el-form-item label="确认新的登录密码" prop="rePassword">
        <el-input v-model="formState.rePassword" :name="Math.random().toString(36).substring(2, 15)" autocomplete="new-password" type="password" placeholder="请输入新登录密码" />
      </el-form-item>

      <el-button
        :loading="isLoading"
        type="primary" class="w-full mt-8" @click="handleSubmit"
      >
        确定
      </el-button>
    </el-form>
  </section>
</template>
